import { render, staticRenderFns } from "./accessmanagementlog-add-or-update.vue?vue&type=template&id=7bfb7896&"
import script from "./accessmanagementlog-add-or-update.vue?vue&type=script&lang=js&"
export * from "./accessmanagementlog-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports